import { Routes, Route } from 'react-router-dom';
import Home from '../pages/home'
import Categories from '../pages/categories';
import AboutUs from '../pages/about_us';
import ContactUs from '../pages/contact_us';
import Shop from '../pages/shop';
function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/categories" element={<Categories />} />
      <Route path="/about_us" element={<AboutUs />} />
      <Route path="/contact_us" element={<ContactUs />} />
      <Route path="/shop/:factoryId?" element={<Shop />} />
    </Routes>
  );
}

export default AppRoutes;
